var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#139448;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.3,69c-1.4-1.4-1.4-3.9,0-5.4L63,6.9c1.4-1.4,3.9-1.4,5.4,0c1.4,1.4,1.4,3.9,0,5.4L11.6,69 C10.1,70.6,7.7,70.6,6.3,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63,69L6.3,12.3c-1.4-1.4-1.4-3.9,0-5.4c1.4-1.4,3.9-1.4,5.4,0l56.8,56.8c1.4,1.4,1.4,3.9,0,5.4 C66.9,70.6,64.6,70.6,63,69z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a7cfcc99b501367b5608a37cdfa91c23.svg";
export { ForwardRef as ReactComponent };